<script lang="ts" setup>
import btnIcon from "@/assets/images/AI.gif";
import initAiChatBiSdk from "./init-aiChatBi-sdk";
import { fetchConfigSearch } from "./service";
import { request } from "@/apis/request";

const aiChatBiSdk = ref();
const userId = ref("");
const roleId = ref("");
const userName = ref("");
// 是否展示
const isShow = ref(false);
// 白名单
const whiteList = ref<string[]>([]);
// 提示词
const prompts = ref({
  prologue: "",
  question: [],
});
// ai配置
const aiConfig = ref({
  config: {},
  // 打开默认全屏
  fullscreen: true,
});

// 计时器
const timer = ref<NodeJS.Timeout | null>(null);

// 轮询次数
const count = ref(0);

const getUsername = async () => {
  try {
    const host = window.location.host;
    const isSit = host.includes("localhost") || host.includes("sit");
    const systemKey = isSit
      ? "5d9f1cfa7eeef20c6d84f022"
      : "5d9f143fbc7cf20c91f560e7";

    const res = await request({
      url: "/eos-qmp-core-base/system/currentemp",
      method: "get",
      headers: { systemKey, "gw-bdus-rid": roleId.value },
    });

    const { data = {} } = res as any;
    userName.value = data?.empName || "";
  } catch (e) {
    console.log("获取用户名失败:", e);
  }
};

const init = async () => {
  // 不在白名单或还没初始化，不展示，白名单包括工号与角色id
  if (
    !whiteList.value.includes(userId.value) &&
    !whiteList.value.includes(roleId.value)
  ) {
    console.log("不在白名单，返回:", {
      userId: userId.value,
      roleId: roleId.value,
      whiteList: whiteList.value,
    });
    return;
  }
  console.log("通过白名单检查，开始展示");

  // 获取用户名
  if (!userName.value) {
    await getUsername();
  }

  const { aiChatBi, config } = initAiChatBiSdk(userId.value, userName.value, prompts.value);
  aiChatBiSdk.value = aiChatBi;
  aiConfig.value.config = config;
  isShow.value = true;
};

onMounted(async () => {
  try {
    isShow.value = false;

    // 先轮询等待 gw-bdus-rid 设置到 sessionStorage
    await new Promise<void>((resolve) => {
      let pollCount = 0;
      const pollTimer = setInterval(() => {
        pollCount++;
        const rid = window.sessionStorage.getItem("gw-bdus-rid");
        if (rid) {
          clearInterval(pollTimer);
          resolve();
        } else if (pollCount >= 3) {
          clearInterval(pollTimer);
          resolve();
        }
      }, 1000);
    });

    // 确保有 gw-bdus-rid 后再发请求
    const res = await fetchConfigSearch("ai_agent_search_white_list");
    const res2 = await fetchConfigSearch("ai_agent_prompts");
    whiteList.value = res ? res.configValue.split(",") : [];
    prompts.value = res2 ? JSON.parse(res2.configValue) : {};

    // 然后轮询获取 userId 和 roleId 并检查白名单
    userId.value = window.sessionStorage.getItem("userid") || "";
    roleId.value = window.sessionStorage.getItem("gw-bdus-rid") || "";
    timer.value = setInterval(() => {
      count.value++;
      userId.value = window.sessionStorage.getItem("userid") || "";
      roleId.value = window.sessionStorage.getItem("gw-bdus-rid") || "";
      if ((count.value >= 10 || aiChatBiSdk.value) && timer.value) {
        clearInterval(timer.value);
        timer.value = null;
        return;
      } else if (userId.value && roleId.value && timer.value) {
        init();
      }
    }, 1000);
  } catch (e) {
    console.log(e);
  }
});

const openAiChatBiSdk = () => {
  // 如果还没有userId.value，说明还没有初始化sdk，需要重新初始化sdk
  if (!userId.value) {
    init();
    return;
  }
  if (!aiChatBiSdk.value) return;
  aiChatBiSdk.value.open(aiConfig.value);
};
</script>

<template>
  <div v-if="isShow" style="position: absolute; left: 0; top: calc(50% - 16px); margin-left: 0;">
    <img
      class="part-to-ai-wrapper"
      :src="btnIcon"
      alt="AI助手"
      @click="openAiChatBiSdk"
    />
  </div>
</template>

<style scoped lang="less">
@import url(./index.less);
</style>
